import React, { useState, useEffect } from "react";
import { Table, Input, DatePicker, Select, Card } from "antd";
import { debounce } from "lodash";
import api from "../../api";
import moment from "moment";

const { RangePicker } = DatePicker;
const { Option } = Select;

const ProductChangeLog = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 25,
    total: 0,
  });
  const [filters, setFilters] = useState({
    search: "",
    date: null,
    type: null,
  });

  // Fetch data from API
  const fetchData = async (
    page = 1,
    perPage = pagination.pageSize,
    filters = {}
  ) => {
    setLoading(true);
    try {
      const params = {
        page,
        per_page: perPage,
        ...filters,
      };
      const response = await api.get("/panel/setting/activityLogs", { params });
      setData(response.data.data);
      setPagination({
        current: response.data.meta.current_page,
        pageSize: response.data.meta.per_page,
        total: response.data.meta.total,
      });
    } catch (error) {
      console.error("خطا در دریافت داده‌ها:", error);
    } finally {
      setLoading(false);
    }
  };

  // Fetch data on component mount and when filters change
  useEffect(() => {
    fetchData(1, pagination.pageSize, filters);
  }, [filters, pagination.pageSize]);

  // Debounced search handler
  const handleSearch = debounce((value) => {
    setFilters((prevFilters) => ({ ...prevFilters, search: value }));
  }, 300);

  // Handle filter changes
  const handleFilterChange = (key, value) => {
    setFilters((prevFilters) => ({ ...prevFilters, [key]: value }));
  };

  // Handle page size change
  const handlePageSizeChange = (current, pageSize) => {
    setPagination((prevPagination) => ({ ...prevPagination, pageSize }));
    fetchData(1, pageSize, filters);
  };

  // Columns for the table
  const columns = [
    {
      title: "ایجاد کننده",
      dataIndex: "creator",
      key: "creator",
      render: (creator) => creator.name,
    },

    {
      title: " عملیات",
      dataIndex: "action",
      key: "action",
    },

    {
      title: "محصول",
      dataIndex: "post",
      key: "post",
      render: (post) => (
        <>
          <p>
            <strong>عنوان:</strong> {post.title}
          </p>
          <p>
            <strong>کد محصول:</strong> {post.id}
          </p>
          <p>
            <strong>کد فنی:</strong> {post.technical_code}
          </p>
        </>
      ),
    },

    {
        title: " پیام",
        dataIndex: "message",
        key: "message",
      },

    {
      title: "تاریخ ایجاد",
      dataIndex: "created_at",
      key: "created_at",
    },
  ];

  return (
    <Card title="گزارش تغییرات محصول">
      <div className="mb-4 flex items-center">
        <Input
          placeholder="جستجو..."
          allowClear
          onChange={(e) => handleSearch(e.target.value)}
          style={{ width: 200, marginRight: 8 }}
        />

        {/* <Select
          className="mr-4"
          allowClear
          placeholder="نوع تغییر"
          style={{ width: 120 }}
          onChange={(value) => handleFilterChange("type", value)}
        >
          <Option value="increase">افزایش</Option>
          <Option value="decrease">کاهش</Option>
        </Select> */}
      </div>
      <Table
        columns={columns}
        dataSource={data}
        loading={loading}
        pagination={{
          current: pagination.current,
          pageSize: pagination.pageSize,
          total: pagination.total,
          onChange: (page) => fetchData(page, pagination.pageSize, filters),
          onShowSizeChange: handlePageSizeChange,
        }}
        rowKey="id"
      />
    </Card>
  );
};

export default ProductChangeLog;
